import React from 'react';
import {Tree} from 'primereact/tree';
import PropTypes from 'prop-types';
import {classNames} from 'primereact/utils';

/**
 * Planning Maestro Tree component. The component is styled and doesn't have any additional functionality comparing to the primereact Tree.
 * Only attributes currently utilized are defined in the interface - additional attributes supported by the base primereact Tree component should be added as needed.
 */
const TreePM = ({
  className = null,
  value = null,
  selectionMode = null,
  selectionKeys = null,
  metaKeySelection = null,
  expandedKeys = null,
  filter = null,
  filterMode = null,
  filterPlaceholder = null,
  dragdropScope = null,
  nodeTemplate = null,
  onSelect = null,
  onUnselect = null,
  onSelectionChange = null,
  onToggle = null,
  onDragDrop = null,
}) => {
  TreePM.propTypes = {
    className: PropTypes.string,
    value: PropTypes.array,
    selectionMode: PropTypes.string,
    selectionKeys: PropTypes.any,
    metaKeySelection: PropTypes.bool,
    expandedKeys: PropTypes.any,
    filter: PropTypes.bool,
    filterMode: PropTypes.string,
    filterPlaceholder: PropTypes.string,
    dragdropScope: PropTypes.string,
    nodeTemplate: PropTypes.func,
    onSelect: PropTypes.func,
    onUnselect: PropTypes.func,
    onSelectionChange: PropTypes.func,
    onToggle: PropTypes.func,
    onDragDrop: PropTypes.func,
  };

  return (
    <Tree
      className={classNames(className, 'planning-maestro-tree')}
      value={value}
      selectionMode={selectionMode}
      metaKeySelection={metaKeySelection}
      dragdropScope={dragdropScope}
      onDragDrop={onDragDrop}
      selectionKeys={selectionKeys}
      onSelect={onSelect}
      onUnselect={onUnselect}
      onSelectionChange={onSelectionChange}
      expandedKeys={expandedKeys}
      onToggle={onToggle}
      nodeTemplate={nodeTemplate}
      filter={filter}
      filterMode={filterMode}
      filterPlaceholder={filterPlaceholder}></Tree>
  );
};

export default TreePM;